var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrowexaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 80,
    viewBox: "0 0 76 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M48.6121 29.8628H39.3203L75.1763 0L48.6121 29.8628Z",
    fill: "#F96302"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M58.94 29.8628H53.3281L75.1775 0L58.94 29.8628Z",
    fill: "#F96302"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M42.1272 54.9678H33.5254L3.48828 0L42.1272 54.9678Z",
    fill: "#F96302"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M43.5523 58.1315L39.4124 65.7531L35.2266 58.1315H43.5523Z",
    fill: "#F96302"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M46.5891 52.5658L3.48828 0L39.3213 29.8628L46.5891 52.5658Z",
    fill: "#F96302"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M64.9177 38.1087L52.9121 40.9264L48.9102 48.2939L44.1953 33.5588H56.9369L64.9177 38.1087Z",
    fill: "#F96302"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M15.0339 31.3131L0.820312 22.4213H10.342L15.0339 31.3131Z",
    fill: "#F96302"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M36.4007 68.1042L25.0391 79.9985L32.7668 61.6836L36.4007 68.1042Z",
    fill: "#F96302"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowexaIcon);
export default __webpack_public_path__ + "static/media/GrowexaIcon.6153d800c9f971ef1d60ee37fdc44a24.svg";
export { ForwardRef as ReactComponent };